





























import VueOptions from '@utils/VueOptions'

settings = 
  name: 'PricingModelDiscount'

  vue:
    props: ['discountTable', 'actions']

    data: ->
      discounts:
        drink_distribution: { discount_in_cents: 10, discount_percentage: null }
        food_distribution: { discount_in_cents: null, discount_percentage: 40 }
        food_multi_serving_distribution: { discount_in_cents: 100, discount_percentage: null }

    methods:
      isDiscounted: (pricingModel) ->
        @discountTable[pricingModel]?.discount_in_cents > 0 or @discountTable[pricingModel]?.discount_percentage > 0
        

export default VueOptions.vue settings
